/* IssuePriorityNode.tsx generated by @compiled/babel-plugin v0.38.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Inline } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';
export var IssuePriorityNode = function IssuePriorityNode(_ref) {
  var IssuePriorityField = _ref.IssuePriorityField;
  if (!(IssuePriorityField !== null && IssuePriorityField !== void 0 && IssuePriorityField.priority)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    alignInline: "start"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: IssuePriorityField.priority.name
    // don't need a screen reader announcement as the
    // tooltip content is the same as the items content
    ,
    isScreenReaderAnnouncementDisabled: true
  }, /*#__PURE__*/React.createElement("img", {
    height: "16",
    width: "16",
    src: IssuePriorityField.priority.iconUrl,
    alt: IssuePriorityField.priority.name
  })));
};